<template>
    <div class="setuppage">
        <TitleComponent :title="t('number15')"></TitleComponent>
        <div class="setupContent">
<!-- 
            <div class="user">
                <el-upload class="avatar-uploader" :limit="1" :http-request="CoverCustomUpload"
                    :before-upload="beforeUpload" :show-file-list="false">
                    <div class="avatar">
                        <img :src="userStore.userInfo?.avatar" />
                    </div>
                </el-upload>
                <div class="name">{{  formData.userform.nickname }}</div>
            </div> -->
           
            <div class="item" @click="goPage('/userInfoPage')">
                <div>{{ $t('setup1') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
            <div class="item" @click="goPage('/address')">
                <div>{{ $t('setup2') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
            <div class="item" @click="goPage('/internal')">
                <div>{{ $t('setup10') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
            <div class="item" @click="goPage('/member/affiliate')">
                <div>{{ $t('setup631') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
           
            <div class="item" @click="goPage('/webinfo/ShippingPolicy')">
                <div> {{ $t('setup133') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
            <div class="item" @click="goPage('/webinfo/pack')">
                <div> {{ $t('setup134') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
            <div class="item" @click="goPage('/webinfo/termsOfService')">
                <div> {{ $t('setup135') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
            <div class="item" @click="goPage('/webinfo/paymentMethods')">
                <div> {{ $t('setup136') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
            <div class="item" @click="goPage('/webinfo/returnPolicy')">
                <div> {{ $t('setup137') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
            <div class="item" @click="goPage('/webinfo/privacyPolicy')">
                <div> {{ $t('setup138') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
            <div class="item" @click="goPage('/webinfo/aboutUs')">
                <div> {{ $t('setup130') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
            <div class="item" @click="goPage('/webinfo/intellectualPropertyRights')">
                <div> {{ $t('setup628') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
            <!-- <div class="item">
                <div>{{ $t('setup3') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div> -->
            <!-- <div class="item">
                <div>{{ $t('setup4') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
            <div class="item">
                <div>{{ $t('setup5') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
            <div class="item">
                <div>{{ $t('setup6') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div> -->
            <!-- <div class="item">
                <div>{{ $t('setup7') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div>
            <div class="item">
                <div>{{ $t('setup8') }}</div>
                <div><svg-icon icon-class="you" /></div>
            </div> -->
            <div class="tuichu" @click="quit()">{{ $t('setup9') }}</div>
        </div>
    </div>
</template>
<script setup>
import TitleComponent from '@/components/TitleComponent/index.vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
const router = useRouter()
const goPage = (url) => {
    router.push(url)
}

import { setAvatarAPI, setLogoutAPI } from '@/apis/user'
import { useUserStore } from '@/stores/userStore'
import { setshelvesFilterAPI } from '@/apis/pay'
import axios from 'axios'
const userStore = useUserStore()

const quit = () => {
    ElMessageBox.confirm(t('home2'), t('home3'), {
        confirmButtonText: t('home4'),
        cancelButtonText: t('home5'),
        type: "warning",
        lockScroll: false,
    }).then(async () => {
        const res = await setLogoutAPI()
        if (res.code == 0) {
            // 1. 清除用户信息 触发action
            userStore.clearUserInfo()
            // 2. 跳转到登录页
            router.push('/login')
        }

    })
}
// 上传前的检查
const beforeUpload = (file) => {
    // 检查文件类型
    const isValidType = ['image/jpeg', 'image/png', 'image/gif'].includes(file.type)
    if (!isValidType) {
        ElMessage.error(t('number18'))
        return false
    }

    // 检查文件大小（小于10MB）
    const isLt10M = file.size / 1024 / 1024 < 10
    if (!isLt10M) {
        ElMessage.error(t('number19'))
        return false
    }

    return true
}
// 封面上传方法
const CoverCustomUpload = async (options) => {
    try {
        // 1. 获取文件扩展名
        const fileExt = options.file.name.split('.').pop()

        // 2. 调用后端接口获取预签名URL
        const { data: presignedData } = await setshelvesFilterAPI({
            fileExtension: fileExt,
            bucketName: 'shap-head-test'
        })

        // 3. 准备表单数据
        const formData = new FormData()
        // 添加后端返回的所有表单字段
        Object.entries(presignedData.formData).forEach(([key, value]) => {
            formData.append(key, value)
        })
        console.log(presignedData.formData)
        // 添加文件
        formData.append('file', options.file)

        // // 4. 执行上传
        const response = await axios.post(presignedData.url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })

        // // 5. 上传成功
        if (response.status === 204) {
            console.log(response)
            ElMessage.success(t('number20'))
            // 构建文件访问URL
            const fileUrl = `${presignedData.url}${presignedData.formData.key}`
            console.log(fileUrl)
            // 可以在这里处理上传成功后的逻辑，比如将fileUrl保存到表单中

            const res = await setAvatarAPI({ avatar: fileUrl })
            if (res.code == 0) {
                getUser()
            }

        }
    } catch (error) {
        ElMessage.error(error.message)
        throw error
    }
}
const formData = reactive({
   
    userform: {
        nickname: '',
        mobile: '',
        email: '',
        password: '',
        balance: null,
        telegram: '',
        watchApp: '',
        introduce:''
    }

})
const getUser = async () => {
    userStore.getUser()
    formData.userform = userStore.userInfo;


}
</script>
<style scoped lang="scss">
.setuppage {

    background-color: #fff;
    height: 100vh;

    .setupContent {
        padding-top: 54px;

        .user {
            text-align: center;

            .name {
                padding: 10px 0 10px 0;
                font-size: 15px;
            }

            .avatar-uploader {
                display: flex;
                justify-content: center;
            }

            .avatar {
                width: 85px;
                height: 85px;
                border-radius: 50%;
                overflow: hidden;


                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    background: none
                }
            }
        }

        .item {
            display: flex;
            align-items: center;
            height: 48px;
            padding: 0 14px;
            justify-content: space-between;
            border-bottom: 1px solid #F3F6F8;
            >div:last-child{
                width: 21px;
                height: 21px;
                border-radius: 50%;
                background-color: #F8F8F8;
               text-align: center;
            }
        }

        .tuichu {
            text-align: center;
            padding: 9px;
            position: fixed;
        bottom: 5px;
        width: 100%;
        border-top: 4px solid #c8c9cc1c;
    // border-bottom: 4px solid #c8c9cc1c;
        }

    }
}
</style>